/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Top_Gorilla_SupportInputs */

const fr_full_top_gorilla_support = /** @type {(inputs: Full_Top_Gorilla_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette action supprimera tous les facteurs d'authentification à facteurs multiples de cet
			utilisateur, y compris les applications d'authentification, les clés de sécurité et les
			méthodes d'authentification par SMS. L'utilisateur devra réenregistrer ses méthodes MFA après
			cette action.`)
};

/**

* @param {Full_Top_Gorilla_SupportInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const full_top_gorilla_support = /** @type {((inputs?: Full_Top_Gorilla_SupportInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Top_Gorilla_SupportInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_full_top_gorilla_support(inputs)
});